<template>
  <BufferingPage />
</template>

<script>
import BufferingPage from '../components/BufferingPage.vue'
import { submitAnswers } from '../api'
import { quizStore } from '../store/quiz'

export default {
  name: 'QuizBufferingView',
  components: { BufferingPage },
  props: { id: { type: [String, Number], required: true } },
  created () {
    const state = quizStore.getState()
    if (!state.quiz || String(state.quizId) !== String(this.id)) {
      this.$router.replace({ name: 'QuizLanding', params: { id: this.id } })
      return
    }
    if (!quizStore.isAllAnswered()) {
      const idx = quizStore.firstUnansweredIndex()
      if (idx >= 0) quizStore.goToQuestion(idx)
      this.$router.replace({ name: 'QuizTest', params: { id: this.id } })
      return
    }
    this.timer = setTimeout(() => this.finish(), 4500)
  },
  beforeDestroy () {
    if (this.timer) clearTimeout(this.timer)
  },
  methods: {
    async finish () {
      const state = quizStore.getState()
      try {
        const data = await submitAnswers(state.quizId, state.answers)
        quizStore.setResult(data)
        this.$router.replace({ name: 'QuizResult', params: { id: this.id } })
      } catch (e) {
        alert('Failed to submit answers: ' + e.message)
        this.$router.replace({ name: 'QuizTest', params: { id: this.id } })
      }
    }
  }
}
</script>
